export default "__VITE_ASSET__361cd61a__"